import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { showNotification, Button } from "react-admin";
import { push } from "react-router-redux";
import dataProviderFactory from "../dataProvider";
import { DELETE } from "react-admin";
import styled from "styled-components";
import { isNil } from "ramda";

const StyledSpanText = styled.span`
  color: black !important;
  font-size: 0.8125rem !important;
`;

class RevokeBlacklistButton extends Component {
  handleClick = async () => {
    const dataProvider = await dataProviderFactory("rest");
    const { push, record, showNotification } = this.props;
    dataProvider(DELETE, "black_lists", { id: record.id })
      .then(() => {
        push("/black_lists/");
      })
      .catch(e => {
        showNotification("bad_item", "warning");
      });
  };
  render() {
    const { record } = this.props;
    if (isNil(record.date_end)) {
      return (
        <Button onClick={this.handleClick}>
          <StyledSpanText>Remove</StyledSpanText>
        </Button>
      );
    }
    return "";
  }
}

RevokeBlacklistButton.propTypes = {
  push: PropTypes.func,
  record: PropTypes.object,
  showNotification: PropTypes.func
};

export default connect(
  null,
  {
    showNotification,
    push
  }
)(RevokeBlacklistButton);



// WEBPACK FOOTER //
// ./src/resources/revokeBlackListButton.js